import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

let runOnce = false;
const newInstance = i18next.createInstance();

if (!runOnce && process.env.NODE_ENV !== 'test') {
    const baseUrl = document.getElementsByTagName('base')[0].href;
    const loadPath =
        process.env.NODE_ENV === 'development'
            ? '/locales/{{lng}}/{{ns}}.json'
            : `${baseUrl}locales/{{lng}}/{{ns}}.json`;

    const options = {
        // order and from where user language should be detected
        order: [
            'htmlTag',
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'path',
            'subdomain',
        ],

        // keys or params to lookup language from
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,

        // cache user language on
        caches: ['localStorage', 'cookie'],
        excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

        // optional expire and domain for set cookie
        cookieMinutes: 10,
        cookieDomain: 'myDomain',

        // optional htmlTag with lang attribute, the default is:
        htmlTag: document.documentElement,

        // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
        cookieOptions: { path: '/', sameSite: 'strict' },
    };

    newInstance
        // detect user language
        // learn more: https://github.com/i18next/i18next-browser-languageDetector
        .use(LanguageDetector)
        .use(HttpApi) // reads translation files from ../public/locales/{language}/translation.json
        // pass the i18n instance to react-i18next.
        .use(initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
            detection: options,
            debug: true,
            fallbackLng: 'en',
            interpolation: { escapeValue: false }, // react already safes from xss
            backend: { loadPath },
            react: { useSuspense: true },
            missingInterpolationHandler: () => '',
        });

    runOnce = true;
}

export default newInstance;
